import React from 'react';
import { cn } from '@/lib/utils';
interface PhoneMockupProps {
  imageUrl?: string;
  alt?: string;
  children?: React.ReactNode;
  className?: string;
  loading?: 'eager' | 'lazy';
  screenAspectRatio?: string;
  imageScale?: number;
}
// All frame metrics are expressed in container-query width units (cqw) so the
// phone scales as one consistent "model" at any rendered width. Values derive
// from a 280px reference (the hero size): e.g. 42px / 280 = 15cqw.
export function PhoneMockup({
  imageUrl,
  alt,
  children,
  className,
  loading,
  screenAspectRatio = '864 / 1795',
  imageScale = 1,
}: PhoneMockupProps) {
  return (
    <div className={cn('awayfx-phone relative mx-auto w-full', className)}>
      <style>{`.awayfx-phone { container-type: inline-size; }`}</style>
      <div
        style={{
          position: 'relative',
          borderRadius: '15cqw',
          background: 'linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 40%, #141414 60%, #222222 100%)',
          padding: '1.79cqw',
          boxShadow:
            '0 0 0 0.5px rgba(0,0,0,0.5), inset 0 0 0 0.5px rgba(255,255,255,0.08), 0 14.3cqw 28.6cqw -7.1cqw rgba(103,80,164,0.35), 0 7.1cqw 14.3cqw -3.6cqw rgba(0,0,0,0.25)',
        }}
      >
        {/* Power button */}
        <div style={{
          position: 'absolute', right: '-1.07cqw', top: '28%',
          width: '1.07cqw', height: '9%',
          background: '#333', borderRadius: '0 0.71cqw 0.71cqw 0',
        }} />
        {/* Screen */}
        <div style={{ borderRadius: '13.57cqw', overflow: 'hidden', position: 'relative', background: '#FEF7FF', aspectRatio: screenAspectRatio }}>
          {/* Punch-hole camera */}
          <div style={{
            position: 'absolute', top: '3.57cqw', left: '50%', transform: 'translateX(-50%)',
            width: '3.57cqw', height: '3.57cqw',
            background: '#0a0a0a', borderRadius: '50%', zIndex: 20,
          }} />
          {/* Screen glare */}
          <div style={{
            position: 'absolute', inset: 0, zIndex: 10, pointerEvents: 'none',
            background: 'linear-gradient(135deg, transparent 0%, rgba(255,255,255,0.04) 50%, rgba(255,255,255,0.08) 100%)',
          }} />
          {/* Content */}
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={alt || 'AwayFX app screenshot'}
                loading={loading}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  display: 'block',
                  transform: imageScale === 1 ? undefined : `scale(${imageScale})`,
                  transformOrigin: 'center',
                }}
              />
            ) : children ? children : (
              <div className="w-full h-full bg-gradient-to-br from-m3-primary-container to-m3-surface flex items-center justify-center p-6">
                <div className="text-m3-primary text-3xl font-bold opacity-20 tracking-tighter">AwayFX</div>
              </div>
            )}
          </div>
          {/* Bottom gesture bar */}
          <div style={{
            position: 'absolute', bottom: '2.86cqw', left: '50%', transform: 'translateX(-50%)',
            width: '34.29cqw', height: '1.43cqw',
            background: 'rgba(255,255,255,0.3)', borderRadius: '0.71cqw', zIndex: 20,
          }} />
        </div>
      </div>
    </div>
  );
}
